function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNoImage = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  width: "1em",
  height: "1em",
  viewBox: "0 0 256 256"
}, props), /*#__PURE__*/React.createElement("g", {
  style: {
    stroke: "none",
    strokeWidth: 0,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "nonzero",
    opacity: 1
  }
}, /*#__PURE__*/React.createElement("path", {
  d: "M89 20.938a1 1 0 0 0-1 1v46.125a7.63 7.63 0 0 1-2.898 5.983L62.328 50.71a1 1 0 0 0-1.372-.057L45.058 64.479l-2.862-2.942a1 1 0 1 0-1.434 1.394l3.521 3.62c.37.38.972.405 1.373.058l15.899-13.826 21.783 22.32a7.6 7.6 0 0 1-2.987.608H24.7a1 1 0 1 0 0 2h55.651c5.32 0 9.648-4.328 9.648-9.647V21.938a1 1 0 0 0-.999-1M89.744 4.864a1 1 0 0 0-1.412-.077l-8.363 7.502H9.648C4.328 12.29 0 16.618 0 21.938v46.125c0 4.528 3.141 8.328 7.356 9.361l-7.024 6.3a1 1 0 0 0 1.335 1.488l88-78.935a1 1 0 0 0 .077-1.413M9.648 14.29h68.091L34.215 53.33 23.428 42.239a1 1 0 0 0-1.385-.046L2 60.201V21.938c0-4.217 3.431-7.648 7.648-7.648M2 68.063v-5.172l20.665-18.568 10.061 10.345-23.44 21.024C5.238 75.501 2 72.157 2 68.063",
  style: {
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    fill: "#000",
    fillRule: "nonzero",
    opacity: 1
  },
  transform: "translate(1.407 1.407)scale(2.81)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.607 35.608c-4.044 0-7.335-3.291-7.335-7.335s3.291-7.335 7.335-7.335 7.335 3.291 7.335 7.335-3.29 7.335-7.335 7.335m0-12.67c-2.942 0-5.335 2.393-5.335 5.335s2.393 5.335 5.335 5.335 5.335-2.393 5.335-5.335-2.393-5.335-5.335-5.335",
  style: {
    stroke: "none",
    strokeWidth: 1,
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    fill: "#000",
    fillRule: "nonzero",
    opacity: 1
  },
  transform: "translate(1.407 1.407)scale(2.81)"
})));
export { SvgNoImage as ReactComponent };
export default __webpack_public_path__ + "static/media/no_image.da5db41a65aa5c7e93d450ed5c847409.svg";